const NAME = 'VERO';
const CNameMapping = {
  [NAME]: NAME,
  Vero: NAME,
  vero: NAME,
};

export { NAME, CNameMapping };
